import { LogLevel } from "@azure/msal-browser";


export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID, // Your app's client ID from Azure AD
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`, // Your directory (tenant) ID
    redirectUri: process.env.REACT_APP_URL, // The URL where users are redirected after signing in
  },
  cache: {
    cacheLocation: "sessionStorage", // Can be 'localStorage' or 'sessionStorage'
    storeAuthStateInCookie: false, // Set to true if you're having issues with Safari
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Info, // Change to DEBUG or TRACE for more detail
      loggerCallback: (level: any, message: string, containsPii?: boolean) => {
        // optional logging callback — keep minimal to avoid runtime noise
        return;
      },
    },
  },
};

